<div class="menu" *ngIf="editMode">
  <div class="block">
    <ico class="up" ico="arrow_upward_24" (click)="move(ord - 1)"></ico>
    <ico class="down" ico="arrow_downward_24"  (click)="move(ord + 1)"></ico>
    <ico ico="edit_24"  (click)="edit()"></ico>
    <ico ico="delete_24"  (click)="delete()"></ico>
  </div>
</div>
